// extracted by mini-css-extract-plugin
export default {"checkbox":"styles_checkbox__ZXqdC","checked":"styles_checked__aCg1e"};